import React from 'react';
import SplitButton from '../ui/SplitButton';

function SignatureStateIcon({ on }) {
    return (
        <svg aria-hidden="true" width="16" height="16" viewBox="0 0 20 20" fill="none">
            {on
                ? <path d="m4 10 4 4 8-8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                : <path d="m5 5 10 10M15 5 5 15" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />}
        </svg>
    );
}

export default function SignatureChip({ chip }) {
    if (!chip) return null;
    const { on, disabled, title, state, onToggle, personalPart, setupHref } = chip;
    const statusLabel = on ? 'Signature on' : 'Signature off';
    const personalSignatures = Array.isArray(chip.personalSignatures)
        ? chip.personalSignatures
        : (personalPart ? [{ key: 'personal', text: personalPart }] : []);
    const options = personalSignatures.map((signature, index) => ({
        key: signature.key || `personal-${index}`,
        label: signature.label || signature.text || 'My signature',
        onSelect: () => { signature.onSelect?.(); chip.onSelect?.(signature); if (!on && !disabled) onToggle?.(); },
        title: signature.text,
        className: 'ia-signature-preview-pill',
    }));
    if (setupHref || chip.editHref) options.push({ key: 'edit', label: 'Edit signatures', href: chip.editHref || setupHref });
    if (!options.length) options.push({ key: 'none', label: 'No signatures yet', displayOnly: true });
    return (
        <div className="ia-signature-control" role="group" aria-label="Message signature" data-signature-chip={state}>
            <SplitButton
                variant="go"
                className="ia-signature-split"
                menuClassName="ia-signature-preview-menu"
                menuSide="primary"
                primaryLabel="Signature"
                primaryAriaLabel="Signature"
                primaryProps={{ title, 'data-signature-preview-trigger': 'true', 'data-signature-label': 'true' }}
                secondaryContent={(
                    <>
                        <SignatureStateIcon on={on} />
                        <span className="sr-only"> {on ? 'On' : 'Off'}</span>
                    </>
                )}
                secondaryAriaLabel={statusLabel}
                secondaryDisabled={disabled}
                onSecondaryClick={onToggle}
                secondaryProps={{ title, 'aria-pressed': on, 'data-signature-state': state, 'data-signature-toggle': 'true', 'data-signature-picker-trigger': 'true' }}
                menuTriggerLabel="Signature options"
                menuLabel="Signature options"
                menuOptions={options}
            />
        </div>
    );
}
